import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 20px 4px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  & .mobile-clock-wise{
    background-color: var(--new-purple-color-selected);
    border: 1px solid ${({ isDark }) => isDark ? 'var(--new-dark-color-border)' : 'var(--new-light-color-border)'} ;
    height: 30px;
    width: 30px;
    border-radius: 6px;
    cursor: pointer;

  }

  & .mobile-chat-to-doc{
    border: 1px solid ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'rgba(249, 249, 249, 1)'};
    background-color: ${({ isDark }) => isDark ? 'var(--new-dark-color)' : 'rgba(249, 249, 249, 1)'};
    border-radius: 6px;
    width: 30px;
    height: 30px;
    text-align: center;
  }
  & p {
    margin: 0px;
    color: ${({ theme }) => theme.colors.primary};
  }
  & .left_button-container {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  & .right_button-container {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  & svg {
    cursor: pointer;
  }
`;

export const ContentBox = styled.div`
  flex-grow: 1;
  height: 0px;
  overflow-y: auto;

  & .hello-user{
    font-family: Poppins;
    font-size: 32px;
    line-height: 48px;
    text-align: center;
    font-weight: 600;
    background: linear-gradient(95.23deg, #7E3FE4 -6.59%, #DF3587 32.62%, #FE395C 71.84%, #FB9631 111.05%);
    /* background: linear-gradient(95.23deg, #7E3FE4 -6.59%, #DF3587 32.62%, #FE395C 71.84%, #FB9631 111.05%); */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  & .main-container{
    max-width: 748px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;

    & .card{
      width: 175px;
      border-radius: 12px;
      padding: 14px;
      background: ${({ isDark }) => isDark ? 'rgba(24, 25, 27, 1)' : 'rgba(249, 249, 249, 1)'};
      border: 1px solid ${({ isDark }) => isDark ? 'rgba(42, 43, 45, 1)' : 'rgba(230, 230, 230, 1)'};
      display: flex;
      flex-direction: column;
      gap: 10px;
      cursor: pointer;

      & span{
        font-size: 14px;
        line-height: 21px;
        font-weight: 400;
        font-weight: Poppins;
        color: rgba(114, 120, 136, 1);
        text-align: left;

      }
    }

    & .search-input div{
        margin: 0px !important;

        & .search-btn{
          transform: translateY(-75%) !important;
        }

        @media only screen and (max-width: 1000px) {
          & .search-btn{
          transform: translateY(-50%) !important;
        }
        }
    }
  }

  & .tags-wrapper {
    min-height: 100%;
    /* max-height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    & .svg-container {
      padding-top: 150px;
    }
    & .about-model {
      margin: 10px 40px;
      border: 1px solid #53555a;
      border-radius: 7px;
      padding: 20px;
      & .about-heading {
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: var(--primary);
      }
      & .about-text {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: var(--primary);
        opacity: 0.5;
        margin-bottom: 0;
        text-align: justify;
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    & .help-heading{
      font-family: Poppins;
      font-size: 24px !important;
      font-weight: 500 !important;
      line-height: 36px !important;
      
    }
  }
`;

export const InputBox = styled.div`
  position: relative;
`;

export const ImageTrigger = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 20px;
  transform: translateY(-100%);
  width: calc(100% - 40px);
  border-radius: 12px;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-inline: 15px;
  background-color: var(--darkbg);
  & p {
    margin: 0px;
    width: 100%;
    cursor: pointer;
    text-align: left;
    padding: 4px 6px;
    border-radius: 8px;
    transition: 0.4s ease;
    color: #ffffff;
    &:hover {
      background-color: var(--lightgrey);
    }
  }
`;
